import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { usePricingStore } from '@/api/pricing';
import { useCutlistState } from '@/api/store';
import Card from '@/blocks/Card';
import { FullPriceDataCard } from '@/blocks/Price';
import { StepNavigation } from '@/blocks/StepNavigation';
import { DetailsForm } from '@/pages/AccountDetails';
import { Button } from '@/primitives/Button';
import { useCurrentFeatures, useTicker } from '@/theme';
import { currencyFormatter } from '@/utils/format';

const Header = () => {
  const { t } = useTranslation();
  return (
    <div className="opposites">
      <h1>{t('account-details.opposites.title')}</h1>
      <StepNavigation />
    </div>
  );
};

const StarterAside = () => {
  const { t } = useTranslation();
  const source = useTicker();
  const navigate = useNavigate();
  const { orderId, currency } = useCutlistState();
  const { showPricing, manualQuote, totalAmountExclVAT, totalAmountInclVAT } =
    usePricingStore();
  const { vatDisplayMode } = useCurrentFeatures();

  const totalAmount =
    vatDisplayMode === 'exclusive' ? totalAmountExclVAT : totalAmountInclVAT;
  const nextButtonLabel = t(
    manualQuote
      ? 'common.cta.reviewOrderWithPriceRequiresManualQuoting'
      : 'common.cta.reviewOrderWithPrice',
    { totalAmount: currencyFormatter(totalAmount / 100, currency) }
  );

  const onNext = () => {
    const isValid = (
      document.querySelector('form#accountDetails') as HTMLFormElement
    )?.reportValidity();
    if (!isValid) return;

    navigate(`/cutlist/${orderId}/review`);
    window.analytics.track('Contact details filled', { ticker: source });
  };

  return (
    <aside>
      <Card>
        {showPricing && (
          <FullPriceDataCard
            title={
              manualQuote
                ? t('cutlist-summary.price.estimated.title')
                : t('cutlist-summary.price.total.title')
            }
          />
        )}
        <Button name="theNextButton" onClick={onNext}>
          {nextButtonLabel}
        </Button>
      </Card>
    </aside>
  );
};

export const StarterDetails = () => {
  return (
    <div className="content">
      <Header />
      <section className="layout">
        <main>
          <DetailsForm accountDetailsFirst />
        </main>
        <StarterAside />
      </section>
    </div>
  );
};
